export default __webpack_public_path__ + "static/media/love.c99a5f4c.svga";